module.exports = __webpack_public_path__ + "static/media/facebook.93f83a14.svg";